export const ConvertResponseCreditBillableRucs = (res) => {
  const rucs = res.billable_rucs.map((e) => {
    return {
      district: e.district,
      address: e.billable_address,
      name: e.billable_ruc_name,
      id: e.billable_ruc,
    };
  });

  return {
    rucs,
    num_pages: res.num_pages,
    page_size: res.page_size,
    count: res.count,
    page: res.page,
  };
};
